import { Color, ContentTableItem, IconName } from '@elearning-platform/ui';

export const mockSkeletonTable: ContentTableItem = {
  type: 'lessonItem',
  data: [
    { value: '', type: 'image', name: 'image' },
    { value: '', type: 'title', name: 'title', contentType: '' },
    {
      type: 'label',
      value: {
        list: ['-', '-'],
        colorsData: {
          textColor: Color.Gray600,
          backgroundColor: Color.White,
          borderColor: Color.Gray300,
        },
      },
      name: 'labels',
    },
    {
      icons: [
        { name: IconName.Award, color: Color.Silver },
        { name: IconName.CheckmarkCircle, color: Color.Green300 },
      ],
      type: 'icons',
      name: 'status',
    },
    {
      type: 'action',
      name: 'actions',
      value: [{ actionType: 'download' }],
    },
  ],
};
